@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="expandedField().value()" (click)="toggleExpanded()">
        {{ title }}
    </h2>
    @if (tooltip != null) {
        <div class="info-tooltip" (click)="tooltip.show = !tooltip.show" (clickOutside)="tooltip.show = false">
            <ev_tooltip
                title="{{ tooltip.header }}"
                [visible]="tooltip.show"
                [left]="1"
                [bottom]="35"
                [arrowTopAlign]="143"
                [arrowAlignLeft]="81"
                [arrow]="'none'"
            >
                <div class="rentalToolTip">
                    {{ tooltip.body }}
                </div>
            </ev_tooltip>
        </div>
    }

    <div class="expander" [class]="cssClass.toString()" [class.expanded]="expandedField().value()">
        <div class="min-max-filter">
            @if (fromField().errors().length > 0 || toField().errors().length > 0) {
                <div class="validation-error">
                    <div class="error-icon">!</div>
                    <div class="error-message">
                        @for (error of fromField().errors(); track $index) {
                            <div style="padding-left: 1.25em">{{ error.message }}</div>
                        }
                        @for (error of toField().errors(); track $index) {
                            <div style="padding-left: 1.25em">{{ error.message }}</div>
                        }
                    </div>
                </div>
            }
            <div class="input-wrapper">
                <div class="input-row">
                    <div class="input-container">
                        @if (enableThousandize) {
                            <input
                                type="text"
                                [id]="fromFieldId"
                                [value]="fromField().value() | thousandize"
                                (change)="fromField().value.set($any($event.target).value.replace(/ /g, ''))"
                            />
                        } @else {
                            <input type="text" [id]="fromFieldId" [formField]="fromField" (beforeinput)="onBeforeInput($event)" (afterinput)="onAfterInput($event)"/>
                        }
                        @if (caption) {
                            <div class="caption">{{ caption }}</div>
                        }
                    </div>
                </div>
                <div class="arrow">&nbsp;</div>
                <div class="input-row">
                    <div class="input-container">
                        @if (enableThousandize) {
                            <input
                                type="text"
                                [id]="toFieldId"
                                [value]="toField().value() | thousandize : '∞'"
                                (change)="toField().value.set($any($event.target).value.replace(/ /g, ''))"
                            />
                        } @else {
                            <input type="text" [id]="toFieldId" [formField]="toField" (beforeinput)="onBeforeInput($event)" (afterinput)="onAfterInput($event)"/>
                        }
                        @if (caption) {
                            <div class="caption">{{ caption }}</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
